import { Dispatch, SetStateAction } from 'react';

import { useMutation, useQuery, useQueryClient } from 'react-query';
import { toast } from 'react-toastify';
import { useSetRecoilState } from 'recoil';

import { useInternalRouter } from '@hooks/useInternalRouter';

import { submitAuth } from '@constants/state';
import {
  CREATE_ERROR_MESSAGE,
  CREATE_SUCCESS_MESSAGE,
} from '@constants/toastMessage';

import { create, getList, upload } from '@apis/submitApi';

/** 기업보고자료 제출페이지 로그인 */
export function useSubmitLogin() {
  const router = useInternalRouter();
  const setLogin = useSetRecoilState(submitAuth);

  const { mutate, isLoading } = useMutation(
    ['submit-login'],
    (value: { key: string; email: string }) => create('/get-temp-token', value),
    {
      onSuccess: (res: any) => {
        if (res?.isError) {
          toast.error(`${res?.data?.message} [${res?.data?.errorCode}]`);
          console.log(`ERROR[${res?.data?.errorCode}] : ${res?.data?.message}`);
        } else {
          // console.log(decoder(res?.accessToken.replace('Bearer ', '')));
          localStorage.setItem('submitAccessToken', res?.accessToken);
          setLogin({
            isLogin: true,
          });
          router.replace('/submit/main');
          toast.success('접속되었습니다.');
        }
      },
    }
  );

  return {
    mutate,
    isLoading,
  };
}

/** 기업보고자료 상세조회 */
export function useSubmitDetail() {
  const { data, isLoading } = useQuery(['submit-list'], () =>
    getList('/report/submit', '')
  );

  return {
    data,
    isLoading,
  };
}

const getFormDatas = async (formDatas: FormData[]) => {
  const result = await formDatas.reduce(async (promise, form) => {
    await promise;
    await upload('/report/upload', form);
  }, Promise.resolve());

  return result;
  // const result = await Promise.allSettled(
  //   formDatas.map(async (form) => {
  //     try {
  //       return await upload('/report/upload', form);
  //     } catch (err: any) {
  //       console.error('FORM DATA UPLOAD ERROR : ', err);
  //     }
  //   })
  // );
  // return await result;
};

/** 기업보고자료 통합 업로드 */
export function useSubmitUploadAll(
  setConfirmModalOpen: Dispatch<SetStateAction<boolean>>
) {
  const queryClient = useQueryClient();
  const { mutate, isLoading } = useMutation(getFormDatas, {
    onSuccess: (res: any) => {
      if (res?.[0]?.value?.isError) {
        toast.error(CREATE_ERROR_MESSAGE);
        console.log(`ERROR[${res?.data?.errorCode}] : ${res?.data?.message}`);
      } else {
        toast.success(CREATE_SUCCESS_MESSAGE);
        queryClient.invalidateQueries(['submit-list']);
      }
    },
    onSettled: () => {
      setConfirmModalOpen(false);
    },
  });

  return {
    mutate,
    isLoading,
  };
}
